import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroup } from 'record-it-components/form/FormGroup/FormGroup';
import { BufferedNumberInput, NumberInputProps } from 'record-it-components/input/NumberInput/NumberInput';
import { BufferedTextInput } from 'record-it-components/input/TextInput/TextInput';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { TimeTrackingConfiguration } from '../../../classes/entities/TimeTrackingConfiguration/timeTrackingConfigurationTypes';
import { AnyPropertyChanged, useEntityPropertyChangedCallback } from '../../../hooks/entity/useEntityPropertyChangedCallback';
export type EditTimeTrackingConfigurationFormProps = ComponentProps<'div'> & {
  timeTrackingConfiguration: TimeTrackingConfiguration;
  onPropertyChanged: AnyPropertyChanged<TimeTrackingConfiguration>;
};
export const EditTimeTrackingConfigurationForm: FunctionComponent<EditTimeTrackingConfigurationFormProps> = React.memo(props => {
  const $ = _c(24);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let onPropertyChanged;
  let remainingProps;
  let timeTrackingConfiguration;
  if ($[2] !== t0) {
    ({
      timeTrackingConfiguration,
      onPropertyChanged,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = onPropertyChanged;
    $[4] = remainingProps;
    $[5] = timeTrackingConfiguration;
  } else {
    onPropertyChanged = $[3];
    remainingProps = $[4];
    timeTrackingConfiguration = $[5];
  }
  const {
    t
  } = useTranslation();
  const maxWorkHoursPerDayChanged = useEntityPropertyChangedCallback(timeTrackingConfiguration, "maxWorkHoursPerDay", onPropertyChanged);
  let t1;
  if ($[6] !== maxWorkHoursPerDayChanged) {
    t1 = value => {
      maxWorkHoursPerDayChanged(value ?? 0);
    };
    $[6] = maxWorkHoursPerDayChanged;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const handleMaxWorkHoursPerDayInput = t1;
  const handleNameInput = useEntityPropertyChangedCallback(timeTrackingConfiguration, "name", onPropertyChanged);
  const t2 = timeTrackingConfiguration.name;
  let t3;
  if ($[8] !== t) {
    t3 = t("entities.TimeTrackingConfiguration.name");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== handleNameInput || $[11] !== t3 || $[12] !== timeTrackingConfiguration.name) {
    t4 = <FormGroup><BufferedTextInput value={t2} label={t3} onInput={handleNameInput} /></FormGroup>;
    $[10] = handleNameInput;
    $[11] = t3;
    $[12] = timeTrackingConfiguration.name;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = timeTrackingConfiguration.maxWorkHoursPerDay;
  let t6;
  if ($[14] !== t) {
    t6 = t("entities.TimeTrackingConfiguration.maxWorkHoursPerDay");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== handleMaxWorkHoursPerDayInput || $[17] !== t6 || $[18] !== timeTrackingConfiguration.maxWorkHoursPerDay) {
    t7 = <FormGroup><BufferedNumberInput value={t5} label={t6} onInput={handleMaxWorkHoursPerDayInput} data-testid="EditTimeTrackingConfigurationForm.MaxWorkHoursPerDayInput" /></FormGroup>;
    $[16] = handleMaxWorkHoursPerDayInput;
    $[17] = t6;
    $[18] = timeTrackingConfiguration.maxWorkHoursPerDay;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== remainingProps || $[21] !== t4 || $[22] !== t7) {
    t8 = <div {...remainingProps}>{t4}{t7}</div>;
    $[20] = remainingProps;
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
});